import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-send-sms-dialog',
    templateUrl: './send-sms-dialog.component.html',
    styleUrls: ['./send-sms-dialog.component.scss']
})
export class SendSmsDialogComponent implements OnInit {
    message: string;
    isSendingMessage: boolean;
    students = [];
    users = [];
    sendToAll: boolean;
    mode: string;

    constructor(public dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private commonService: CommonService,
                public toastService: ToastMessagesService,
                public dialogRef: MatDialogRef<SendSmsDialogComponent>) {
        this.students = data.students;
        this.users = data.users;
        this.mode = data.mode ? data.mode : 'default';
        this.isSendingMessage = false;
        this.sendToAll = false;
    }

    ngOnInit(): void {
    }

    close() {
        this.dialogRef.close();
    }

    /**
     *
     * @param to - self, parents, users
     */
    promptConfirmation(to: string) {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: to === 'self' ? 'Δοκιμαστική αποστολή' : to === 'parents' ? 'Αποστολή μηνύματος σε γονείς' : 'Αποστολή μηνύματος σε χρήστες',
                message: 'Είστε σίγουροι ότι θέλετε να πραγματοποιήσετε την αποστολή του μηνύματος?'
            }
        });

        confirm.afterClosed().subscribe(async (response: any) => {
            if (response) {
                switch (to) {
                    case 'self':
                        await this.sendTestSms();
                        break;
                    case 'parents':
                        await this.sendSmsToParents();
                        break;
                    case 'users':
                        await this.sendSmsToUsers();
                        break;
                }
            }
        });
    }

    async sendTestSms() {
        try {
            this.isSendingMessage = true;
            await this.commonService.insertItem(`messages/sendTestSms`, {message: this.message});
            this.toastService.toastMessages(`To μήνυμα εστάλη με επιτυχία`);
        } catch (e) {
            this.toastService.toastErrorMessage(e.serverMessage);
        } finally {
            this.isSendingMessage = false;
        }
    }

    async sendSmsToParents() {
        const studentIds = this.students.map(s => s.id);
        try {
            this.isSendingMessage = true;

            await this.commonService.insertItem(`messages/sendSmsToParents`, {
                message: this.message,
                studentIds,
                sendToAll: this.sendToAll
            });
            this.toastService.toastMessages(`To μήνυμα εστάλη με επιτυχία`);
        } catch (e) {
            console.log(e);
            this.toastService.toastErrorMessage(e.serverMessage);
        } finally {
            this.isSendingMessage = false;
        }
    }

    async sendSmsToUsers() {
        const userIds = this.users.map(s => s.id);
        try {
            this.isSendingMessage = true;
            console.log(userIds);
            await this.commonService.insertItem(`messages/sendSmsToUsers`, {message: this.message, userIds});
            this.toastService.toastMessages(`To μήνυμα εστάλη με επιτυχία`);
        } catch (e) {
            console.log(e);
            this.toastService.toastErrorMessage(e.serverMessage);
        } finally {
            this.isSendingMessage = false;
        }
    }

    updateMessage($event: string) {
        this.message = $event;
    }
}
